export const EVENT_NAMES = {
  HOME_PAGE_LOADED: "Buzz_HomePage_Loaded",
  SECTION_CLICKED: "Buzz_Section_clicked",
  SUB_PAGE_LOADED: "Buzz_SubPage_Loaded",
};

export const EVENT_FIELDS = {
  SECTION_NAME: "sectionName",
  ITEM_NAME: "itemName",
  CATEGORY: "category",
  SELECTED_CATEGORY: "selectedCategory",
  REDIRECTION_URL: "redirectionUrl",
  CURRENT_URL: "currentUrl",
  TITLE: "title",
  SUB_TITLE: "subTitle",
  PAGE_NUMBER: "pageNumber",
  CURRENT_PAGE: "currentPage",
  TOTAL_PAGES: "totalPages",
  SOURCE: "source",
};

export const EVENT_CATEGORY = {
  CALCULATORS: "Calculators",
};

export const EVENT_SECTION_NAME = {
    BREADCRUMB: "Breadcrumb",
    PAGINATION: "Pagination",
}
